import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import { BrandType, DebtType, OutDebtExtra } from '../../generated/graphql';
import RenderText from '../../dictionaries/RenderText';
import { TranquiTheme } from '../../containers/App/theme';
import { useBrandContext } from '../../dictionaries/context/BankContext';

interface DebtIntroductionTextProps {
  name: string;
  document: string | number;
  className?: string;
  variant: 'details' | 'select';
  bank: string;
  debtType?: string;
  extra?: OutDebtExtra;
}

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  introductionTextBox: {
    maxWidth: 'auto',
    [theme.breakpoints.between(780, 1130)]: {
      maxWidth: 510,
    },
    [theme.breakpoints.up(1130)]: {
      maxWidth: '80%',
    },
  },
  name: {
    ...theme.typography.body2,
    fontWeight: 600,
    color: theme.palette.indigo.main,
  },
  nameText: {
    ...theme.typography.body2,
    color: theme.palette.indigo.main,
  },
}));

const DebtIntroductionText: React.FC<DebtIntroductionTextProps> = (props) => {
  const { name, className, variant, bank: bankProp, debtType, document, extra = {} } = props;
  const [ brand = '' ] = useBrandContext();
  const classes = useStyles();
  const isCC = debtType === DebtType.CreditCard;
  const bank = brand === BrandType.Apex ? brand : bankProp;

  return (
    <Box className={cn(classes.introductionTextBox, className)} data-test="cy-introductionText-portal">
      <Typography className={cn(classes.name, 'mb-1')} data-test="cy-introductionName-text">
        <RenderText textKey="general_debtsView_welcome_name" context={{ name }} />
      </Typography>
      <Typography className={classes.nameText} data-test="cy-introductionDescription-text">
        <RenderText
          isMarkdown
          textKey={`general_${variant}_welcome_introduction`}
          context={{
            cc: document,
            bank,
            product: `${debtType}`,
            ending: isCC ? 'a' : '',
            brand,
            issuingEntity: extra.issuingEntity || '',
          }}
        />
      </Typography>
    </Box>
  );
};

export default DebtIntroductionText;
